import { type LeadGenerationRunStatusEnum } from '@crm/api'
import { runStatusColor } from '@crm/features/lead-generation/utils'
import { useLocales } from '@shared/locales'
import { Tag } from 'antd'

type Props = {
  status?: LeadGenerationRunStatusEnum
}

export const RunStatusTag = ({ status }: Props) => {
  const { t } = useLocales()

  if (!status) return <>-</>

  return (
    <Tag color={runStatusColor[status]}>
      {t(`lead_generation.${status}`, status)}
    </Tag>
  )
}
